/** @jsxImportSource @emotion/react */
import { sidebarContainer } from '../styles/Sidebar.styles';
import CategorySection from './CategorySection';
import DataSelectionSection from './DataSelectionSection';
import DisplayMethodSection from './DisplayMethodSection';
import ParameterSection from './ParameterSection';

const Sidebar = ({
    selectedCategory,
    setSelectedCategory,
    imageLayerVisible,
    onChangeVisibleHandle,
    imageLayerOpacity,
    onChangeOpacityHandle,
    selectedData,
    setSelectedData,
    selectedSubArray,
    handleCheckboxChange,
    handleRadioChange,
    mode,
    setMode,
    selectedRadioOption,
    setSelectedRadioOption,
    pointVectorLayerVisible,
    setPointVectorLayerVisible,
    mapData,
    status,
}) => {
    return (
        <div css={sidebarContainer}>
            {/* 1. 카테고리 섹션 */}
            <CategorySection
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                imageLayerVisible={imageLayerVisible}
                onChangeVisibleHandle={onChangeVisibleHandle}
                imageLayerOpacity={imageLayerOpacity}
                onChangeOpacityHandle={onChangeOpacityHandle}
            />

            {/* 2. 데이터 선택 섹션 */}
            <DataSelectionSection
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                selectedSubArray={selectedSubArray}
                handleCheckboxChange={handleCheckboxChange}
                handleRadioChange={handleRadioChange}
            />

            {/* 3. 표시 방법 및 파라미터 섹션 */}
            <DisplayMethodSection
                selectedData={selectedData}
                mode={mode}
                setMode={setMode}
                selectedRadioOption={selectedRadioOption}
                setSelectedRadioOption={setSelectedRadioOption}
                pointVectorLayerVisible={pointVectorLayerVisible}
                setPointVectorLayerVisible={setPointVectorLayerVisible}
                mapData={mapData}
                selectedSubArray={selectedSubArray}
                status={status}
            />

            {/* 4. 파라미터 섹션 - 데이터가 선택되었을 때만 표시 */}
            {/* <ParameterSection
                selectedData={selectedData}
                mode={mode}
                selectedRadioOption={selectedRadioOption}
                setSelectedRadioOption={setSelectedRadioOption}
                pointVectorLayerVisible={pointVectorLayerVisible}
                setPointVectorLayerVisible={setPointVectorLayerVisible}
                mapData={mapData}
                selectedSubArray={selectedSubArray}
                status={status}
            /> */}
        </div>
    );
};

export default Sidebar;
